import React, { useState, useEffect } from 'react';
import { EditWorkingType, WorkingTypeNameCheck, HEADERS, getOrgId } from '../../api';
import './leaveorgin.css';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';

export default function EditWorkingDays() {
  const navigate = useNavigate();
  const daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  const [formValues, setFormValues] = useState({
    name: '',
    hoursPerDay: '',
  });
  const [isDisabled, setIsDisabled] = useState(false);
  const [selectedDays, setSelectedDays] = useState({});
  // const { working_id } = useParams();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  // Extract working_id values from URL parameters
  const working_id = searchParams.get('working_id');

  // $&


  useEffect(() => {
    // Extract values from URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const workingName = urlParams.get('working_name') || '';
    const hoursPerDay = urlParams.get('hours_per_day') || '';


    // Set initial form values
    setFormValues({
      name: workingName,
      hoursPerDay,
    });

    // Set initial selectedDays based on URL parameters
    const initialSelectedDays = {};
    daysOfWeek.forEach(day => {
      initialSelectedDays[day] = urlParams.get(day.toLowerCase()) === 'true';
    });
    setSelectedDays(initialSelectedDays);

    // Set initial isDisabled based on URL parameters
    setIsDisabled(urlParams.get('is_disabled') === 'true');
  }, []);

  const handleSwitchChange = () => {
    setIsDisabled((prev) => !prev);
  };

  const handleCheckboxChange = (day) => {
    setSelectedDays((prev) => ({
      ...prev,
      [day]: !prev[day],
    }));
  };

  const handleCancel = () => {
    navigate('/leave-page/working-days');
  };

  const handleUpdate = async () => {
    // Prepare the data to be sent to the API
    const apiData = {
      working_id: working_id,
      working_name: formValues.name,
      hours_per_day: parseInt(formValues.hoursPerDay, 10),
      monday: selectedDays['Monday'],
      tuesday: selectedDays['Tuesday'],
      wednesday: selectedDays['Wednesday'],
      thursday: selectedDays['Thursday'],
      friday: selectedDays['Friday'],
      saturday: selectedDays['Saturday'],
      sunday: selectedDays['Sunday'],
    };

    // $&

    // Show a confirmation modal before making the API call
    Swal.fire({
      title: 'Are you sure?',
      text: 'You are about to cancel the update',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Update',
      cancelButtonColor: 'blue',
      confirmButtonText: 'Cancel',
      confirmButtonColor: 'grey'

    }).then(async (result) => {
      if (result.isConfirmed) {
        // User confirmed to cancel, you can add additional logic here if needed
        // $&
      } else {
        // User chose to keep the update, make the API call
        const response = await fetch(EditWorkingType, {
          method: 'POST',
          headers: HEADERS,
          body: JSON.stringify(apiData),
        });

        try {
          const data = await response.json();

          if (data.response_code === "0000") {
            navigate('/leave-page/working-days');

            Swal.fire({
              icon: 'success',
              title: 'Success!',
              text: 'Working day updated successfully!',
            });
          } else {
            // Handle other response codes or show an error message
            console.error('API error:', data);
            Swal.fire({
              icon: 'error',
              title: 'Error!',
              text: 'Something went wrong. Please try again.',
            });
          }
        } catch (error) {
          console.error('JSON parsing error:', error);

          // Show an error alert for parsing errors
          Swal.fire({
            icon: 'error',
            title: 'Error!',
            text: 'Failed to process the server response. Please try again.',
          });
        }
      }
    });
  };

  // Check email when registering or adding user
  function WorkingNameCheck(working_Name) {
    const OrgID = getOrgId();

    const json_Body = {
      organization_id: OrgID,
      working_name: working_Name,
    };

    // $&

    // Make an HTTP request to the endpoint
    return fetch(WorkingTypeNameCheck, { // Using the imported endpoint
      method: 'POST', // or 'GET' depending on your server endpoint
      headers: HEADERS,
      body: JSON.stringify(json_Body),
    })
      .then(response => response.json())
      .then(data => {
        // Handle the response accordingly
        if (data.response_code === "0000") {
          // $&
          return true; // Name is available
        } else if (data.response_code === "5000") {
          // $&
          return false; // Name already exists
        } else {
          // $&
          throw new Error('Unexpected response code');
        }
      })
      .catch(error => {
        console.error('Error:', error);
        throw error;
      });
  }

  return (
    <div className="p-2">

      <span className='breadcrumb d-flex gap-2'>
        <Link className="previou-link text-decoration-none" to="/leave-page">Leave Setting</Link>
        <span>/</span>
        <Link className="previou-link text-decoration-none" to="/leave-page/working-days">Working Days</Link>
        <span>/</span>
        <span className="current-link text-decoration-none">Edit Working Days</span>
      </span>
      <span className="title">Edit Wording Days</span>
      <div className="conner">
        <div className="row mt-3">
          <div className="col-md-6 mt-1">
            <div className="edit-card" style={{ border: '1px solid #e1e1e1', borderRadius: '8px', padding: '16px' }}>
              <div style={{ justifyContent: 'space-between' }}>
                <div className='input-group'>
                  <div className="form-group col-md-12">
                    <label>Name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Casual"
                      required
                      value={formValues.name}
                      onChange={(e) => setFormValues({ ...formValues, name: e.target.value })}
                    />
                  </div>
                </div>
                <div className='input-group'>
                  <div className="form-group col-md-12">
                    <label>Hours Per Day</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder=""
                      required
                      value={formValues.hoursPerDay}
                      onChange={(e) => setFormValues({ ...formValues, hoursPerDay: e.target.value })}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6 mt-1">
            <div className="card">
              <div className="card-body">
                <span className="title">Working Days</span>
                <table className="table">
                  <thead>
                    <tr>
                      <th className="heading-table">Days</th>
                      <th className="heading-table">Select</th>
                    </tr>
                  </thead>
                  <tbody>
                    {daysOfWeek.map((day) => (
                      <tr key={day}>
                        <td className='body-table'>{day}</td>
                        <td className='body-table'>
                          <input
                            className='check-box'
                            type="checkbox"
                            checked={selectedDays[day]}
                            onChange={() => handleCheckboxChange(day)}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='mt-3' style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
        <button className="button" onClick={() => navigate('/leave-page/working-days')} style={{ marginRight: '20px' }}>
          Cancel
        </button>
        <button className="button-outline" onClick={handleUpdate} variant="primary">
          Update
        </button>
      </div>
    </div>
  );
}


